import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import BootstrapTable from "react-bootstrap-table-next";
import { BootstrapTable as BootstrapTableOld, TableHeaderColumn } from "react-bootstrap-table";
import { Alert, Alignment, Button, FormGroup, HTMLSelect, InputGroup } from "@blueprintjs/core";
import { formatCnpj } from "../../utils";
import moment from "moment";
import { DateRangePicker30 } from "../utils/DateRangePicker30";
import { toast } from "react-toastify";
import { Pager } from "../utils/Pager";
import ReactJson from "react-json-view";
import { BotsStore } from "../../stores/relatorio/BotsStore";
import { getOptions, getTag, options } from "../utils/getStatus";
import { IconButton } from "@mui/material";
import { BotsAdminStore } from "../../stores/admin/BotsAdminStore";
import LoadingModal from "../loading/LoadingModal";
import { DefaultSelect, filterItens, renderItens } from "../utils/DefaultSelect";

interface state {

  date1: string,
  date2: string

}

@observer
export class BotsPage extends React.Component<{}, state> {

  obs = observable({
    selectedPeriod: [] as any,
    open_create: false as boolean,
    selectedRows: [] as any,
    allSelected: false as boolean,
    tipo: {} as {cod: null, descricao: ""},
    status: "" as string,
    finalizado: "todos" as string,
    loading: false as boolean,
    erro: "todos" as string,
    cnpj: "" as string,
    id: "" as string,
    task_id: "" as string,
    open_erros_bots: false as boolean,
    erros_solicitacoes: [] as any,
    open_detalhes: false as boolean,
    tarefa: {} as any,
    loading_download: false as boolean,
    loading_solicitacoes: false as boolean
  })

  constructor(props) {
    super(props);
    this.state = { date1: "", date2: "" }
  }

  /**
   * Executa ações iniciais ao montar o componente de gerenciamento de tarefas.
   * 
   * A função realiza as seguintes ações:
   * 1. Define o título da página como "Gerenciamento de Tarefas" utilizando `AppStore.setTitle`.
   * 2. Inicializa a lista de bots em `BotsStore.obs.tabelaBots` como um array vazio.
   * 3. Define a página atual da tabela de bots como a primeira (`currentPageBot = 1`).
   * 4. Zera o total de bots registrados (`length_bots = 0`), preparando a tabela para uma nova carga de dados.
   * 
   * Essa função é chamada automaticamente após o componente ser montado no DOM (ciclo de vida do React).
   * 
   * @returns {Promise<void>} Não retorna valor diretamente, apenas executa configurações iniciais no estado global (`BotsStore`).
  */

  async componentDidMount() {
    AppStore.setTitle("Gerenciamento de Tarefas");

    BotsStore.obs.tabelaBots = []
    BotsStore.obs.currentPageBot = 1
    BotsStore.obs.length_bots = 0
  }

  /**
   * Reinicia as tarefas selecionadas na interface de bots.
   * 
   * A função executa as seguintes ações:
   * 1. Verifica se há tarefas selecionadas em `this.obs.selectedRows`. Caso contrário, exibe um aviso ao usuário.
   * 2. Filtra as tarefas que podem ser reiniciadas com base no tipo e status:
   *    - Para tarefas do tipo "sitfis", apenas as que não possuem status 2 (Enviada) ou 4 (Concluída) são permitidas.
   *    - Para os tipos "pgdas", "gera_das", "mudanca_regime" e "caixapostal", apenas as que não possuem status 2 são permitidas.
   *    - Os demais tipos são sempre permitidos.
   * 3. Se houver tarefas inválidas (concluídas ou já enviadas), exibe uma mensagem de erro informando que elas não podem ser reiniciadas.
   * 4. Envia as tarefas válidas para reinício utilizando `BotsStore.handleRestartBots`.
   * 5. Limpa a seleção atual (`this.obs.selectedRows`) e executa nova busca com `this.handleBuscaClick`.
   * 6. Caso haja erros no retorno da reinicialização, os exibe configurando `this.obs.erros_solicitacoes` e abrindo a modal `this.obs.open_erros_bots`.
   * 
   * @returns {Promise<void>} Não retorna valor diretamente, mas altera o estado de `this.obs` com base no resultado das ações.
  */

  handleRestart = async () => {

    const selectedRows = this.obs.selectedRows;

    if (selectedRows.length === 0) {
      toast.warning("Por favor, selecione pelo menos uma tarefa para reiniciar.", {});
      return;
    }

    const okTasks = selectedRows.filter(row => {
      if (row.tipo === "sitfis") {
        return row?.status !== 4 && row?.status !== 2;
      }

      if (["pgdas", "gera_das", "mudanca_regime", "caixapostal"].includes(row.tipo)) {
        return row?.status !== 2;
      }

      return true;
    });

    if (selectedRows.length !== okTasks.length) {

      toast.error(`Tarefas concluídas e enviadas à SERPRO não podem ser reiniciadas.`);

    }

    let params = {
      itens: okTasks
    }

    this.obs.loading = true

    let resp: any = await BotsStore.handleRestartBots(params)

    this.obs.selectedRows = []

    this.handleBuscaClick()

    if (resp?.length > 0) {

      this.obs.erros_solicitacoes = resp

      this.obs.open_erros_bots = true

    }

    this.obs.selectedRows = []

    this.obs.loading = false

  };

  /**
   * Realiza a mudança de página na listagem de tarefas (bots) e busca os dados correspondentes.
   * 
   * A função executa as seguintes ações:
   * 1. Verifica se o tipo da tarefa (`this.obs.tipo`) está definido. Caso seja "todos", exibe um aviso ao usuário solicitando a seleção de um tipo específico.
   * 2. Monta um objeto `params` com os filtros e informações atuais:
   *    - `id`, `task_id`, `cnpj`, `tipo`, `status`, `finalizado`, `erro` (vindos de `this.obs`)
   *    - `dataInicial` e `dataFinal` (vindos do estado local `this.state`)
   *    - Página atual (`page`) e limite de itens por página (`limit = 15`)
   * 3. Executa a busca de bots da página solicitada chamando `BotsStore.handleGetBots(params)`.
   * 
   * @param {number} page Número da página que deve ser carregada.
   * 
   * @returns {Promise<void>} Não retorna valor diretamente, apenas realiza a busca de dados e atualiza o estado de bots.
  */

  handlePageChange = async (page: number) => {

    if (!this.obs.tipo.cod) {
      toast.warn("Selecione o tipo da tarefa que deseja buscar!")
      return
    }

    let params = {
      id: this.obs.id,
      task_id: this.obs.task_id,
      cnpj: this.obs.cnpj,
      tipo: this.obs.tipo.cod,
      status: this.obs.status,
      finalizado: this.obs.finalizado,
      erro: this.obs.erro,
      dataInicial: this.state.date1,
      dataFinal: this.state.date2,
      page: page,
      limit: 15
    }

    await BotsStore.handleGetBots(params)

  };

  /**
   * Gerencia a seleção e deseleção de linhas (tarefas) na tabela de bots.
   * 
   * A função executa as seguintes ações:
   * 1. Se o item for selecionado (`checked === true`), adiciona o objeto com `id`, `tipo` e `status` da linha à lista `this.obs.selectedRows`.
   * 2. Se o item for desmarcado (`checked === false`), remove da lista `this.obs.selectedRows` o item correspondente ao `row._id`.
   * 
   * Essa função é geralmente acionada por um checkbox ou interação na tabela de seleção de tarefas.
   * 
   * @param {Object} row Objeto representando a linha (tarefa) selecionada ou desmarcada.
   * @param {boolean} checked Indica se a linha foi selecionada (`true`) ou desmarcada (`false`).
   * 
   * @returns {void} Não retorna valor. Apenas atualiza a lista de tarefas selecionadas no estado observável.
  */

  onSelect = (row, checked) => {

    if (checked) {

      this.obs.selectedRows.push({ id: row._id, tipo: this.obs.tipo.cod, status: row.status });

    } else {

      let index = this.obs.selectedRows.findIndex(obj => obj.id === row._id);

      if (index !== -1) {
        this.obs.selectedRows.splice(index, 1);
      }

    }

  }

  /**
   * Gerencia a seleção ou deseleção de todas as linhas exibidas na tabela de bots.
   * 
   * A função executa as seguintes ações:
   * 1. Se o parâmetro `check` for `true`, itera sobre todas as linhas recebidas em `row` e adiciona cada uma à lista `this.obs.selectedRows`, incluindo o `id`, `tipo` e `status`.
   * 2. Se `check` for `false`, limpa completamente a lista de itens selecionados (`this.obs.selectedRows = []`).
   * 
   * Essa função é geralmente utilizada quando o usuário marca ou desmarca o checkbox "Selecionar Todos" da tabela.
   * 
   * @param {boolean} check Indica se todas as linhas devem ser selecionadas (`true`) ou desmarcadas (`false`).
   * @param {Array<Object>} row Lista de objetos representando as linhas atualmente visíveis na tabela.
   * 
   * @returns {Promise<void>} Não retorna valor diretamente, apenas atualiza a lista de tarefas selecionadas no estado observável.
  */

  handleRowSelectAll = async (check, row) => {

    if (check) {

      row?.map(value => {

        this.obs.selectedRows.push({ id: value._id, tipo: this.obs.tipo.cod, status: value.status });

      });

    } else {

      this.obs.selectedRows = [];
    }

  };

  /**
   * Manipula a alteração de período de datas selecionado pelo usuário.
   * 
   * A função executa as seguintes ações:
   * 1. Converte o valor recebido (`val`) para string e separa as duas datas utilizando vírgula como delimitador.
   * 2. Formata a primeira data (`array[0]`) e a segunda data (`array[1]`) no formato "YYYY-MM-DD" utilizando a biblioteca `moment`, e atualiza o estado local com `this.setState`.
   * 3. Verifica se alguma das datas é inválida. Se for, define o valor correspondente no estado como string vazia.
   * 4. Atualiza `this.obs.selectedPeriod` com o valor original recebido.
   * 
   * Essa função é utilizada normalmente em componentes de seleção de período, como `DateRangePicker`.
   * 
   * @param {any} val Valor recebido do componente de seleção de datas, contendo duas datas (início e fim).
   * 
   * @returns {void} Não retorna valor. Apenas atualiza o estado local (`this.state`) e observável (`this.obs`) com as datas selecionadas.
  */

  handleDateChange = (val: any) => {
    var string = val.toString();

    var array = string.split(",");

    this.setState({ date1: moment(array[0]).format("YYYY-MM-DD") });
    this.setState({ date2: moment(array[1]).format("YYYY-MM-DD") });

    if (moment(array[0]).format("YYYY-MM-DD") == "Data inválida") {
      this.setState({ date1: "" });
    }

    if (moment(array[1]).format("YYYY-MM-DD") == "Data inválida") {
      this.setState({ date2: "" });
    }

    this.obs.selectedPeriod = val;
  };

  /**
   * Realiza a busca de tarefas com base nos filtros informados pelo usuário.
   * 
   * A função executa as seguintes ações:
   * 1. Verifica se o tipo da tarefa (`this.obs.tipo`) foi selecionado. Se estiver como "todos", exibe um aviso e interrompe a busca.
   * 2. Monta o objeto `params` contendo os filtros aplicados:
   *    - `id`, `task_id`, `cnpj`, `tipo`, `status`, `finalizado`, `erro` (de `this.obs`)
   *    - `dataInicial` e `dataFinal` (de `this.state`)
   *    - Define a página como 1 e o limite de resultados por página como 15.
   * 3. Atualiza o controle de paginação para a primeira página (`BotsStore.obs.currentPageBot = 1`).
   * 4. Define o indicador de carregamento de solicitações como `true` (`this.obs.loading_solicitacoes = true`).
   * 5. Executa a busca dos bots chamando `BotsStore.handleGetBots(params)`.
   * 6. Ao finalizar a busca, define o indicador de carregamento como `false`.
   * 
   * Essa função normalmente é acionada ao clicar no botão de "Buscar" ou "Filtrar" na interface.
   * 
   * @returns {Promise<void>} Não retorna valor diretamente, mas atualiza o estado de carregamento e os dados da tabela de bots.
  */

  handleBuscaClick = async () => {

    if (!this.obs.tipo.cod) {
      toast.warn("Selecione o tipo da tarefa que deseja buscar!")
      return
    }

    let params = {
      id: this.obs.id,
      task_id: this.obs.task_id,
      cnpj: this.obs.cnpj,
      tipo: this.obs.tipo.cod,
      status: this.obs.status,
      finalizado: this.obs.finalizado,
      erro: this.obs.erro,
      dataInicial: this.state.date1,
      dataFinal: this.state.date2,
      page: 1,
      limit: 15
    }

    BotsStore.obs.currentPageBot = 1

    this.obs.loading_solicitacoes = true

    await BotsStore.handleGetBots(params)

    this.obs.loading_solicitacoes = false

  };

  /**
   * Exibe os detalhes de uma tarefa (bot) selecionada.
   * 
   * A função executa as seguintes ações:
   * 1. Atribui a linha selecionada (`row`) ao estado observável `this.obs.tarefa`, armazenando os dados da tarefa atual.
   * 2. Define a flag `this.obs.open_detalhes` como `true`, o que geralmente aciona a abertura de um modal ou painel de detalhes na interface.
   * 
   * Essa função é normalmente acionada ao clicar em um botão ou link de "Visualizar Detalhes" em uma linha da tabela.
   * 
   * @param {Object} row Objeto representando a tarefa selecionada, contendo os dados que serão exibidos em detalhe.
   * 
   * @returns {void} Não retorna valor. Apenas atualiza o estado observável para exibir os detalhes da tarefa.
  */

  handleViewDetalhes(row) {

    this.obs.tarefa = row

    this.obs.open_detalhes = true

  }

  /**
   * Realiza o download de um arquivo relacionado à tarefa (bot) selecionada.
   * 
   * A função executa as seguintes ações:
   * 1. Define a flag `this.obs.loading_download` como `true` para indicar o início do processo de download (útil para exibir um loader na interface).
   * 2. Chama o método `BotsAdminStore.handleDownloadFile`, passando o tipo de tarefa (`this.obs.tipo`) e a linha da tarefa (`row`) como parâmetros.
   * 3. Após a conclusão do download, define `this.obs.loading_download` como `false`, encerrando o estado de carregamento.
   * 
   * Essa função é acionada normalmente ao clicar em um botão de "Download" na tabela ou nos detalhes da tarefa.
   * 
   * @param {Object} row Objeto representando a tarefa cujo arquivo será baixado.
   * 
   * @returns {Promise<void>} Não retorna valor diretamente, apenas executa o download e atualiza o estado de carregamento.
  */

  async handleDownloadFile(row) {

    this.obs.loading_download = true

    await BotsAdminStore.handleDownloadFile(this.obs.tipo.cod, row)

    this.obs.loading_download = false

  }

  render() {

    const formatDetalhes = (row) => {

      return (<IconButton onClick={(e) => this.handleViewDetalhes(row)}>
        <img src="/images/view.png" width="18px"/>
      </IconButton>);

    }

    const formatDownload = (row) => {

      if (!(row.status == 2)) return (<></>)

      const tiposIgnorados = [
        "caixapostal", "calculo", "contestacao", "manifestacao", "solicitacao_sefa", "xml_integration", 
        "dec_sefa_ler", "dec_sefa_download", "nfe_fazenda", "manifestacao_chaves", "parcelamentos",
        "email", "telegram", "whatsapp"
      ];

      if (tiposIgnorados.includes(this.obs.tipo.cod)) return (<></>)

      return (

        <IconButton onClick={(e) => this.handleDownloadFile(row)} disabled={!(row.status == 2)}>
          <img src="/images/download.svg" width="18px" />
        </IconButton>

      );

    }

    const columns = [
      {
        dataField: '_id',
        text: 'ID',
        isKey: true,
      },
      {
        dataField: 'tipo',
        text: 'Tipo',
        editable: false,
        formatter: (cell) => (this.obs.tipo.cod || "").toUpperCase(),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'cnpj',
        text: 'CNPJ',
        editable: false,
        formatter: (cell, row) => {

          if (cell) {

            return formatCnpj(cell)

          } else {

            if (row.cnpj_destino) {

              return formatCnpj(row.cnpj_destino)

            }

            return "N/A"

          }

        },
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'status',
        text: "Status",
        editable: false,
        formatter: (cell, row) => formatStatusTask(cell, row),
        headerStyle: { width: '300px', textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'status',
        text: "Finalizado",
        editable: false,
        formatter: (cell) => formatFinalizado(cell),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'status',
        text: "Erro",
        editable: false,
        formatter: (cell) => formatErro(cell),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'inserted_at',
        text: 'Criado em',
        editable: false,
        formatter: (cell, row) => formatDate(cell, row._insertedTS),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: '_modifiedTS',
        text: 'Última atualização',
        editable: false,
        formatter: (cell, row) => {
          if (!cell || cell.trim() === "") {
            return "Sem atualização";
          }
          return formatDate(cell, row.updated_at);
        },
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'detalhes',
        text: "Detalhes",
        editable: false,
        formatter: (cell, row) => formatDetalhes(row),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      },
      {
        dataField: 'download',
        text: "Arquivo",
        editable: false,
        formatter: (cell, row) => formatDownload(row),
        headerStyle: { textAlign: 'center' },
        style: { textAlign: 'center' },
      }
    ];

    const formatStatusTask = (status, row) => {

      return getTag(status, this.obs.tipo.cod, row);

    }

    const formatDate = (dateString, optionalDate) => {

      const date = new Date((dateString || optionalDate));

      return moment.utc(date).format("DD/MM/YYYY HH:mm");
    };

    const formatFinalizado = (status) => {

      const { tipo } = this.obs;

      const sim = <span style={{ fontSize: 12 }}>SIM</span>;
      const nao = <span style={{ fontSize: 12 }}>NÃO</span>;

      switch (status) {
        case 2:
        case 4:
        case 5: {
          const isTipoIntegracao = ["xml_integration", "sitfis", "download_sefa"].includes(tipo.cod);

          if (status === 4 && isTipoIntegracao) return nao;
          if (status === 5 && tipo.cod === "solicitacao_sefa") return sim;
          if (status === 5 && tipo.cod === "download_sefa") return nao;

          return sim;
        }

        case 8:
        case 9:
        case 10:
          return sim;

        default:
          return nao;
      }

    };

    const formatErro = (status) => {

      const { tipo } = this.obs;

      const sim = <span className="bot-tag-erro-sim">SIM</span>;
      const nao = <span className="bot-tag-erro-nao">NÃO</span>;

      switch (status) {
        case 3:
        case 8:
        case 9:
          return sim;

        case 4:
          if (["solicitacao_sefa", "xml_integration", "download_sefa", "dec_sefa_ler", "nfe_fazenda"].includes(tipo.cod)) {
            return nao;
          }
          return sim;

        case 5:
          if (tipo.cod === "solicitacao_sefa") return nao;

          if (["download_sefa", "xml_integration", "dec_sefa_download"].includes(tipo.cod)) return sim;

          return nao;

        default:
          return nao;
      }

    };

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: false,
      style: { backgroundColor: '#e9f6ff' },
      onSelect: this.onSelect,
      onSelectAll: this.handleRowSelectAll,
      selected: this.obs.selectedRows?.map(value => value.id),
      nonSelectable: BotsStore.obs.tabelaBots.map(value => {
        if (["solicitacao_sefa", "download_sefa", "email", "telegram", "whatsapp"].includes(value.tipo)) return value._id
        if (value.gratuito && value.status == 2 && value.tipo == "receita") return value._id
        if (value.status == 2 && value.tipo == "dec_download") return value._id
      })
    };

    let erros = this.obs.erros_solicitacoes?.map(map_bot => {
      return (
        {
          id: map_bot.id,
          erro: map_bot.error,
        }
      )
    });

    let anexoText = this.obs.tipo.cod ? `${this.obs.tipo.descricao.substring(0, 30)}` : "SELECIONE";

    return (
      <>

        <div style={{ display: 'flex' }}>

          <FormGroup style={{ width: '300px' }} label="Buscar ID">
            <InputGroup
              placeholder="Digite o ID"
              value={this.obs.id}
              onChange={(e) => {
                this.obs.id = e.target.value;
              }}
            />
          </FormGroup>

          <FormGroup style={{ width: '300px', marginLeft: 15 }} label="Buscar CNPJ">
            <InputGroup
              placeholder="Digite o CNPJ"
              value={this.obs.cnpj}
              onChange={(e) => {
                this.obs.cnpj = e.target.value;
              }}
            />
          </FormGroup>

          <FormGroup style={{ width: '250px', marginLeft: 15 }} label="Tipo" className="empresaSelect selectValues">
            <DefaultSelect
              items={options}
              itemRenderer={renderItens}
              itemPredicate={filterItens}
              onItemSelect={(e: any) => this.obs.tipo = e}
              matchTargetWidth={true}
              inputProps={{ placeholder: "Filtrar um Tipo" }}
            >
              <Button
                className="tipo-select-bots"
                text={anexoText}
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
              />
            </DefaultSelect>
          </FormGroup>

          <FormGroup style={{ width: '250px', marginLeft: 15 }} label="Status">
            <HTMLSelect
              onChange={(e) => this.obs.status = e.target.value}
              value={this.obs.status}
            >
              {getOptions(this.obs.tipo.cod).map(({ value, label }) => (
                <option key={value} value={value}>{value} - {label}</option>
              ))}
            </HTMLSelect>
          </FormGroup>

          <FormGroup style={{ width: '250px', marginLeft: 15 }} label="Finalizado">
            <HTMLSelect
              onChange={(e) => this.obs.finalizado = e.target.value}
              value={this.obs.finalizado}
            >
              <option value="todos"> TODOS </option>
              <option value="sim"> SIM </option>
              <option value="nao"> NÃO </option>

            </HTMLSelect>
          </FormGroup>

          <FormGroup style={{ width: '250px', marginLeft: 15 }} label="Erro">
            <HTMLSelect
              onChange={(e) => this.obs.erro = e.target.value}
              value={this.obs.erro}
            >
              <option value="todos"> TODOS </option>
              <option value="sim"> SIM </option>
              <option value="nao"> NÃO </option>

            </HTMLSelect>
          </FormGroup>

        </div>

        <div style={{ display: 'flex' }}>
          <FormGroup label="Período criado" className="inputsPeriodoBots">
            <DateRangePicker30
              onChange={this.handleDateChange}
              value={this.obs.selectedPeriod}
            />
          </FormGroup>

          <FormGroup label={"\u0020"}>
            <MDBBtn
              className="btnDefault btnBuscarBots mt22"
              onClick={() => this.handleBuscaClick()}
            >
              Buscar
            </MDBBtn>
          </FormGroup>

        </div>

        <MDBRow>
          <MDBCol md="2">
            <MDBBtn
              disabled={this.obs.loading}
              className="btnDefault btnBuscarNfe"
              onClick={() => this.handleRestart()}
              style={{ marginTop: '5px' }}
            >
              Reiniciar tasks selecionadas
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        {/* @ts-ignore */}
        <BootstrapTable keyField="_id" data={BotsStore.obs.tabelaBots} columns={columns} wrapperClasses="TableDefault tabela-excesso" selectRow={selectRowProp} />

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={BotsStore.obs.currentPageBot}
            totalCount={BotsStore.obs.length_bots}
            pageSize={15}
            onPageChange={page => this.handlePageChange(BotsStore.obs.currentPageBot = page)}
          />
        </div>
        <div style={{ marginBottom: 120 }} />

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_erros_bots}
          onConfirm={() => this.obs.open_erros_bots = false}
          className="AlertUser"
          intent="primary"
        >
          <h2 className="titleSEFAZ">Erros ocorridos durante a Reinicialização</h2>
          <p style={{ marginBottom: 25, marginTop: -25 }}>
            Para as empresas listadas abaixo, será necessário realizar a reinicialização.
          </p>
          <MDBCol md="12">
            {erros.length &&
              <div className="erroBots">
                <BootstrapTableOld data={erros} hover>
                  <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                  <TableHeaderColumn dataField='id' width='20%'>ID</TableHeaderColumn>
                  <TableHeaderColumn dataField='erro' width='50%'>Erro</TableHeaderColumn>
                </BootstrapTableOld>
              </div>
            }
          </MDBCol>
        </Alert>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_detalhes}
          onClose={() => this.obs.open_detalhes = false}
          canOutsideClickCancel={true}
          intent="primary"
        >
          <h2 className="titleSEFAZ">Detalhes</h2>

          <div className="heightResposta">
            <ReactJson collapsed={false} displayDataTypes={false} src={this.obs.tarefa} />
          </div>

        </Alert>

        <LoadingModal open={this.obs.loading_download} onClose={() => this.obs.loading_download = false} title={"Baixando arquivo"} />
        <LoadingModal open={this.obs.loading_solicitacoes} onClose={() => this.obs.loading_solicitacoes = false} title={"Carregando"} />

      </>
    );
  }
}
